import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ChatbotAccessService } from '@shared/services/chatbot-access/chatbot-access.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ChatbotEnabledGuard implements CanActivate {
  constructor(
    private readonly chatbotAccess: ChatbotAccessService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.chatbotAccess.enabled$.pipe(map((enabled) => (enabled ? true : this.router.parseUrl('/home'))));
  }
}
